import { BaseService } from './base.service';
import { CustomResponseEntity, PaginationParams } from '../types/common';
import { 
  OrganizationFileDto, 
  CreateOrganizationFileDto, 
  UpdateOrganizationFileDto 
} from '../types/dtos/training';
import { api } from '../client/axiosClient';

/**
 * Organization File Service handles CRUD operations for organization files.
 *
 * URL Pattern: /api/v1/files
 * Organization context is provided via X-Organization-Id header (injected by axiosClient).
 *
 * Migration: The organizationId constructor parameter has been removed from URL paths.
 * The backend extracts organization context from the X-Organization-Id header for tenant scoping.
 *
 * @deprecated organizationId constructor parameter is deprecated and no longer used.
 */

const BASE_PATH = '/api/v1/files';

export class OrganizationFileService extends BaseService<
  OrganizationFileDto,
  CreateOrganizationFileDto,
  UpdateOrganizationFileDto
> {
  /**
   * @param _organizationId - Deprecated: Organization ID (no longer used, kept for backward compatibility)
   */
  constructor(_organizationId: string) {
    super(BASE_PATH);
  }

  findAll(params?: PaginationParams): Promise<CustomResponseEntity<OrganizationFileDto[]>> {
    return api.get(BASE_PATH, { params });
  }

  // Find files by entity type and ID
  findByEntity(
    entityType: string, 
    entityId: string,
    params?: PaginationParams
  ): Promise<CustomResponseEntity<OrganizationFileDto[]>> {
    return api.get(BASE_PATH, { 
      params: { 
        ...params, 
        entityType, 
        entityId 
      } 
    });
  }

  // Upload file (multipart/form-data)
  uploadFile(formData: FormData): Promise<CustomResponseEntity<OrganizationFileDto>> {
    return api.post(`${BASE_PATH}/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }
}

export const createOrganizationFileService = (_organizationId: string) => 
  new OrganizationFileService(_organizationId);

